import React from 'react';
import { useTranslation } from 'react-i18next';
import { MetaToggle } from 'shared/components/ui/meta-toggle';
import { TaskType } from 'shared/types/task-base';

import * as Styled from './task-type-toggle.style';

export type TaskTypeToggleProps = {
  type: TaskType.Repeating | TaskType.Habit;
  onChange: (value: TaskType.Repeating | TaskType.Habit) => void;
  isPremium?: boolean;
  fullWidth?: boolean;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
};

export const TaskTypeToggle: React.FC<TaskTypeToggleProps> = ({
  type,
  onChange,
  isPremium,
  fullWidth,
  icon,
}) => {
  const { t } = useTranslation();

  const onTypeChange = () => {
    onChange(type === TaskType.Habit ? TaskType.Repeating : TaskType.Habit);
  };

  return (
    <MetaToggle
      label={t('general.labels.habit.repeat.change-type.label')}
      checked={type === TaskType.Habit}
      onChange={onTypeChange}
      fullWidth={fullWidth}
      icon={icon}
      id="type-toggle"
    >
      {isPremium && (
        <Styled.PremiumLabel>{t('general.labels.premium')}</Styled.PremiumLabel>
      )}
    </MetaToggle>
  );
};
